import { Chart, Logger, Core } from '../../sgvizler';
/**
 * Todo Line
 * @class d3.visualization.Line
 * @tutorial d3_visualization_Line
 * @memberof d3.visualization
 */
export class Line extends Chart {
    get icon() {
        return 'fas fa-chart-line';
    }
    get label() {
        return 'Line';
    }
    get subtext() {
        return 'Line';
    }
    get classFullName() {
        return 'd3.visualization.Line';
    }
    get tutorialFilename() {
        return 'tutorial-d3_visualization_Line.html';
    }
    constructor() {
        super();
        //this.addCss(Core.path + '/lib/d3/d3.css')
        let dep = this.addScript(Core.path + 'lib/d3/d3.min.js');
    }
    /**
     * Make a simple line.
     * Available options:
     * -
     * @memberOf Line
     * @returns {Promise<void>}
     * @param result
     */
    draw(result) {
        let currentChart = this;
        return new Promise(function (resolve, reject) {
            // transform query
            // console.log(noCols + " x " + noRows)
            //console.log('test')
            let heightOpt = '100%';
            if (currentChart.height !== '') {
                heightOpt = currentChart.height;
            }
            let opt = Object.assign({
                showRowNumber: true,
                width: currentChart.width,
                height: heightOpt
                // hAxisscaleType: true
            }, currentChart.options);
            // build the datatable
            let cols = result.head.vars;
            let rows = result.results.bindings;
            let noCols = cols.length;
            let noRows = rows.length;
            let dataset = [];
            let label;
            let count;
            for (let row of rows) {
                label = row[cols[0]].value;
                count = Number(row[cols[1]].value);
                if (label === undefined || count === undefined) {
                    Logger.logSimple('Erreur ? D3JS:pie label ' + label + ' count ' + count);
                }
                else {
                    dataset.push({ label: label, count: count });
                }
            }
            console.log(dataset);
            let margin = {
                top: 30,
                right: 20 * 3,
                bottom: 30,
                left: 70
            };
            let width = 800 - margin.left - margin.right;
            let height = 570 - margin.top - margin.bottom;
            // x axis
            let x = d3.scalePoint()
                .domain(dataset.map(function (entry) {
                return entry.label;
            }))
                .rangeRound([0, 800])
                .padding(0.5);
            let xAxis = d3.axisBottom().scale(x).ticks(15);
            // y axis
            let y = d3.scaleLinear().range([height, 0]);
            y.domain([0, d3.max(dataset, function (d) {
                    return d.count;
                })]);
            let yAxis = d3.axisLeft().scale(y).ticks(17);
            let valueline = d3.line()
                .x(function (d) {
                return x(d.label);
            })
                .y(function (d) {
                return y(d.count);
            });
            let svg = d3.select('#' + currentChart.container.id)
                .append('svg')
                .attr('width', width + margin.left + margin.right)
                .attr('height', height + margin.top + margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
            svg.append('path') // Add the valueline path.
                .attr('fill', 'none')
                .attr('stroke', 'steelblue')
                .attr('stroke-linejoin', 'round')
                .attr('stroke-linecap', 'round')
                .attr('stroke-width', 1.5)
                .attr('d', valueline(dataset));
            svg.append('g') // Add the X Axis
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis);
            svg.append('g') // Add the Y Axis
                .attr('class', 'y axis')
                .call(yAxis);
            // finish
            return resolve();
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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